import { makeVar } from '@apollo/client';
export const featureAvailability = makeVar(undefined);
